import { render } from "./CreateSnapshotWizard.vue?vue&type=template&id=1d35911a&scoped=true"
import script from "./CreateSnapshotWizard.vue?vue&type=script&lang=js"
export * from "./CreateSnapshotWizard.vue?vue&type=script&lang=js"

import "./CreateSnapshotWizard.vue?vue&type=style&index=0&id=1d35911a&scoped=true&lang=less"

import exportComponent from "/build/cloudstack/dist/rpmbuild/BUILD/cloudstack-4.22.1.1/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d35911a"]])

export default __exports__